/** @jsx jsx */
import { jsx } from '@emotion/core';
import { RichText } from '@sitecore-jss/sitecore-jss-react';
import { get } from 'lodash';
import { React, Component } from 'react';
import { Icon } from '../../../ui/Icon';

import * as Styles from './index.styles';
import { Picture } from '../../../ui/Picture';
import { CLOUDINARY_BASE_VALUES } from '../../../../utils/constants';
import { Breakpoints } from '../../../../styles/Grid/GridSizes';
import DynamicAnchor from '../../../ui/DynamicAnchor';

const mainImageSizes = {
  [Breakpoints.sm]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.md]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.lg]: {
    ...CLOUDINARY_BASE_VALUES,
  },
  [Breakpoints.xl]: {
    ...CLOUDINARY_BASE_VALUES,
  },
};

export default class Card extends Component {
  render() {
    const { data } = this.props;

    const CTA1Link = get(data, 'Cta1Link', '');
    const CTA1Text = get(data, 'Cta1Text', '');
    const CTA2Link = get(data, 'Cta2Link', '');
    const CTA2Text = get(data, 'Cta2Text', '');
    const Intro = get(data, 'Intro', '');
    const ThemeColour = get(data, 'ThemeColour', '');
    const Title = get(data, 'Title', '');
    const IconSrc = get(data, 'Icon', '');

    //TODO :: remove this when final commit
    const imageSrc = {
      value: { src: IconSrc, alt: 'what we do card' },
    };

    return (
      <div className="swiper-slide" css={[Styles.SwiperSlideCss]}>
        <div
          onClick={() => {
            if (!CTA2Link) {
              return;
            }
            if (CTA2Link && CTA2Link.includes('{') && CTA2Link.includes('?')) {
              const ssrRawJson = document.getElementById('__JSS_STATE__');
              let paramData = {};
              if (ssrRawJson) {
                let ssrRawJsonParse = JSON.parse(ssrRawJson.innerHTML);

                paramData = {
                  locale: get(ssrRawJsonParse, 'sitecore.context.language', ''),
                  countryCode: get(
                    ssrRawJsonParse,
                    'sitecore.context.countryCode.countryCode',
                    '',
                  ),
                  location: '',
                  countryName: get(
                    ssrRawJsonParse,
                    'sitecore.context.countryName.countryName',
                    '',
                  ),
                  location: '',
                };
              }
              window.location = DynamicAnchor(CTA2Link, paramData);
            } else {
              window.location = CTA2Link;
            }
          }}
          aria-hidden="true"
          css={[
            Styles.whatwedocardui,
            ThemeColour && Styles.setHeightlight(ThemeColour),
          ]}
        >
          {IconSrc && (
            <span>
              <Picture
                image={imageSrc}
                imageSizes={mainImageSizes}
                // pictureCss={previewImageStyleImage}
                editable={false}
                instantLoad
              />
            </span>
          )}
          <RichText field={{ value: Title }} tag="h3" />
          {/* <h3>{data.title}</h3> */}
          <p>{Intro}</p>
        </div>
        <div className="findoutlink" css={[Styles.findoutlink]}>
          <a href={CTA1Link}>
            <span>{CTA1Text}</span>
            <span>
              <Icon name="chevron-right" />
            </span>
          </a>

          <a href={CTA2Link}>
            <span>{CTA2Text}</span>
            <span>
              <Icon name="chevron-right" />
            </span>
          </a>
        </div>
      </div>
    );
  }
}
